// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"MessageBox-checkboxWrapper","cannedMessageInput":"MessageBox-cannedMessageInput","schedulerContainer":"MessageBox-schedulerContainer"};